
export const getCluster = (extraConfigs = {}) => extraConfigs.cluster || 'sielte'